import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavItem } from '../NavItem';

interface Props {
  onClick: () => void;
}

export const LogoutBlock = (props: Props) => {
  const { onClick } = props;
  const { t } = useTranslation('sideMenu');

  return (
    <NavItem as="button" size="XS" view="negative" onClick={onClick} data-testid="logout-btn">
      {t('sideMenu:Log Out')}
    </NavItem>
  );
};
